import { FloatingPlayerContextData } from '@contexts/floating-player';

export const selectIsFloatingPlayerVisible = (
  state: FloatingPlayerContextData,
) => state.isVisible;
